import React from 'react';
import {INodeTemplateProps} from '@techsee/techsee-ui-common/lib/simple-tree-control-view';
import {observer} from 'mobx-react';

const removeExtension = (filename: string): string => {
    const lastDotIndex = filename.lastIndexOf('.');

    if (lastDotIndex === -1) {
        return filename;
    }

    return filename.substring(0, lastDotIndex);
};

export const LibraryTreeTemplate: React.FC<INodeTemplateProps> = observer(({node}) => {
    const displayTitle = removeExtension(node.data.title);
    return (
        <span title={node.data.title} style={node.state.selected ? {fontWeight: 'bold'} : undefined}>
            {displayTitle}
        </span>
    );
});
